import { AutoComplete, Input, Tooltip, Breadcrumb, Select } from "antd";
import { ActiveIcon, InactiveIcon, AddIcon } from "../../../../asset/icons";
import {
  EditIcon,
  DeleteIcon,
  DetailIcon,
  SearchIcon,
  AscRed,
  DescGrey,
  CloseIconSearch,
  NoImageLogo,
  ProfileKosong,
  InvitationExpiredIcon,
  InvitationSentIcon,
  DANonActiveIcon,
  DAActiveIcon,
  InvitationOpenedIcon,
  DriverActiveIcon,
  DriverNonactiveIcon,
} from "../../../../asset";
import style from "./DriverList.module.css";
import CustomTable from "../../../../component/table/CustomTable";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import { DriverListColumn } from "../../../../constant/tableConstant";
import DeleteConfirmationModal from "../../../../component/modal/DeleteConfirmationModal";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constant/routeConstant";
import axios from "axios";
import { GROLOG_URL, TOKEN } from "../../../../constant/apiConstant.js";
import { useDispatch, useSelector } from "react-redux";
import Delete from "../../../../component/modal/ModalDelete";
import { setIsAddOrEditPage } from "../../../../store/reducer/page.reducer";
import { resourcePagination } from "../../../../util/resoucePagination";
import CustomPaging from "../../../../component/pagination/pagination";
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';
import { onChanged, permissionButton } from "../../../../util/Util";
import { LoadingOption, dropdownCustom, selectOption } from "../../../../component/select/SelectOption";

const DriverList = (props) => {
  const { token, client_id, grolog_account_id, userId } = useSelector((state) => state.auth);
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;  const navigate = useNavigate();
  const { t } = useTranslation();
  const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] =
    useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [listData, setListData] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);
  const [dropdown, setDropdown] = useState([]);
  const [depot, setDepot] = useState();
  const [depotName, setDepotName] = useState();
  const [isFilter, setIsfilter] = useState(false);
  const [depot1, setDepot1] = useState();
  const [depotName1, setDepotName1] = useState();
  const [sorting, setSorting] = useState("asc");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState();
  const [lims, setLims] = useState();
  const [searchRecommendation, setSearchRecommedation] = useState("");
  const [listRecommendation, setListRecommendation] = useState([]);
  const [filter, setFilter] = useState("");
  const [load, setLoad] = useState(false);
  const [pageDepot, setPageDepot] = useState(1)
  const [limitDepot,setLimitDepot] = useState(10)
  const [loading, setLoading] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  const [filterDepot, setFilterDepot] = useState("")
  const api = GROLOG_URL;
  const dispatch = useDispatch()
  const { permission } = useSelector((state) => state.auth);
    
  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { "Authorization": tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const getListDepot = async (page, limit, filter) => {
    let res2 = await doGet(
      `/depot-configuration?page=${page}&limit=${limit}${filter ? `&filter=depot_name lk ${filter}` : ""}&${param}`,
      token
    );
    let option =[]
    let list = res2?.data?.payload?.data;
    const currentDepot = [...dropdown];
    console.log("masuk");
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.depot_id,
          value: element.depot_name,
        };
        option.push(data);
      }
      setDropdown(selectOption(currentDepot, option, "value"));
    };
}

  const fetchData = async (data, sort, pages) => {
    // setLoad(true);
    let res2 = await doGet(
      `/depot-list-filter?page=1&limit=10&${param}`,
      token
    );
    console.log("res2", res2);
    if(!res2?.data?.payload?.data){
      setLoad(false)
    }else{
      setLoad(true);
    let res = await doGet(
      `/driver?page=${pages ? pages :page}&limit=${limit}&order=id ${
        sort ? sort : sorting
      }&filter=depot_id eq ${
        depot ? depot : res2?.data?.payload?.data[0]?.depot_id
      }${
        (filter && filter !== "")
          ? ", driver_name lk " + filter
          : (data && typeof data !== 'undefined' && filter.length > 0)
            ? ", driver_name lk " + data
            : ""
      }&${param}`,
      token
    );
    let init = await doGet(
      `/driver/initiate?page=${pages ? pages :page}&limit=${limit}&order=id ${
        sort ? sort : sorting
      }&filter=depot_id eq ${
        depot ? depot : res2?.data?.payload?.data[0]?.depot_id
      }${
        (filter && filter !== "")
          ? ", driver_name lk " + filter
          : (data && typeof data !== 'undefined' && filter.length > 0)
            ? ", driver_name lk " + data
            : ""
      }&${param}`,
      token
    );
    let option =[]
    let list = res2?.data?.payload?.data;
    const currentDepot = [...dropdown];
    console.log("masuk");
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.depot_id,
          value: element.depot_name,
        };
        option.push(data);
      }
    }
      setDropdown(selectOption(currentDepot, option, "value"));
    
    // setDepot(res2?.data?.payload?.data[0]?.depot_id);
    setDepot1(res2?.data?.payload?.data[0]?.depot_id);
    setDepotName1(res2?.data?.payload?.data[0]?.depot_name);
    setListData(res?.data?.payload?.data);
    setInitiate(init?.data?.payload?.data);
    setLoad(false);
    handlePagination(pages,limit)
  }
  };
  const handleChange = (value, id) => {
    setPage(1)
    setDepot(value);
    setDepotName(value);
    fetchData();
  };
  const setModal = async (data, condition) => {
    await setData(data);
    await setShowDelete(true);
  };
  useEffect(() => {
    // fetchDepot();
    onChanged(dispatch, false)
    fetchData();
  }, [page, limit, depot, depotName,filter]);

  const handleEdit = (id) => {
    navigate(ROUTES.DRIVER.EDIT, { state: id });
  };

  const onScrollDepot = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight || target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight+1 &&
      !loading
    ) {
      setLoading(true)
      console.log("sini g");
      setPageDepot(pageDepot+1)
      target.scrollTo(0, target.scrollHeight);
      getListDepot(pageDepot, limitDepot, filterDepot)
    }
  };

  const onChangeDepot = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    console.log("value",event.target);
    let filterSearch = value && `${value}`;
    setSearchValue(value)
    let filters = [filterSearch];
    filters = filters.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filters = filters.length !== 0 ? filters.join(", ") : undefined;
    const resetFilter = filters;
    setDropdown([])
    if (value.length >= 2) {
      console.log("value", value);
      setDropdown([])
      setFilterDepot(filters)
      setPageDepot(resetPage)
        setTimeout(() => {
          getListDepot(1,limitDepot,filters)
      }, 256); 
    } else if (!value) {
      setLoading(true)
      setDropdown([])
      setFilterDepot(resetFilter)
      setPageDepot(resetPage)
      getListDepot(1, limitDepot,filters)
    }
  };

  const handleDetail = (id) => {
    navigate(ROUTES.DRIVER.DETAIL, { state: id });
  };

  const handleAdd = (id) => {
    navigate(ROUTES.DRIVER.ADD, { state: depot ? depot : depot1 });
  };

  const dataSource = listData
    ? listData?.map((result) => ({
        photo: (
          <span className="font-roboto text-lg text-[#222222]">
            <img
              className="rounded-full w-14 aspect-square"
              alt="prof"
              src={result?.driver_photo ? result?.driver_photo : ProfileKosong}
            />
          </span>
        ),
        driverId: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.driver_id}
          </span>
        ),

        firstName: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.first_name}
          </span>
        ),
        lastName: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.last_name ? result?.last_name : "-"}
          </span>
        ),
        phone: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.phone}
          </span>
        ),
        vehicleId: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.vehicle_id}
          </span>
        ),
        status: (
          <span className="font-roboto text-lg text-[#222222]">
            <img src={result.status ==="Invitation Expired" ? InvitationExpiredIcon : result.status ==="Invitation Sent" ? InvitationSentIcon : result.status === "Non-Active" ? DriverNonactiveIcon : result.status === "Active" ? DriverActiveIcon : result.status ==="Invitation Opened" ? InvitationOpenedIcon :""} alt="-"/>
          </span>
        ),
        action: (
          <div className="flex gap-[26px]">
            <Tooltip className={
          permissionButton(permission, "update", "driver", "master")
            ? ""
            : "hidden"
        } title={t("USER:EDIT_TOOLTIP")} color="#CF0000">
              <button>
                <img
                  src={EditIcon}
                  alt="edit"
                  onClick={() => handleEdit(result?.driver_id)}
                />
              </button>
            </Tooltip>
            <Tooltip className={
          permissionButton(permission, "delete", "driver", "master")
            ? ""
            : "hidden"
        } title={t("Delete")} color="#CF0000">
              <button onClick={() => setModal(result, "driver")}>
                <img src={DeleteIcon} alt="del" />
              </button>
            </Tooltip>
            <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
              <button
                // onClick={() => handleDelete(result?.customer_id, result?.updated_at)}
                onClick={() => handleDetail(result?.driver_id)}
              >
                <img src={DetailIcon} alt="det" />
              </button>
            </Tooltip>
          </div>
        ),
      }))
    : null;

  const ListColumn = [
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Driver Photo")}
        </span>
      ),
      dataIndex: "photo",
      key: "photo",
      render: (photo) => <span>{photo}</span>,
    },
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div style={{ width: "60%" }}>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("Driver Id")}
            </span>
          </div>
          <div style={{ width: "4%", marginLeft: "40px", marginTop: "3px" }}>
            <div className={style.SortArea}>
              <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "asc" ? AscRed : DescGrey}
                  alt="asc"
                  className={
                    sorting === "asc"
                      ? "w-full cursor-pointer"
                      : "rotate-180 w-full cursor-pointer"
                  }
                  onClick={() => {
                    doSort("asc");
                  }}
                  // disabled={sorting==="asc"}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "asc" ? DescGrey : AscRed}
                  alt="desc"
                  className={
                    sorting === "asc"
                      ? "w-full cursor-pointer"
                      : "rotate-180 w-full cursor-pointer"
                  }
                  onClick={() => {
                    doSort("desc");
                  }}

                  // disabled={sorting==="desc"}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "driverId",
      key: "driverId",
      // sorter: {
      //     compare: (a, b) => a.driverId.localeCompare(b.driverId)

      // },
      render: (driverId) => <span>{driverId}</span>,
    },

    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("USER:FIRST_NAME_FIELD")}
        </span>
      ),
      dataIndex: "firstName",
      key: "firstName",
      render: (firstName) => <span>{firstName}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("USER:LAST_NAME_FIELD")}
        </span>
      ),
      dataIndex: "lastName",
      key: "lastName",
      render: (lastName) => <span>{lastName}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Vehicle ID")}
        </span>
      ),
      dataIndex: "vehicleId",
      key: "vehicleId",
      render: (vehicleId) => <span>{vehicleId}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Phone")}
        </span>
      ),
      dataIndex: "phone",
      key: "phone",
      render: (phone) => <span>{phone}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Status")}
        </span>
      ),
      dataIndex: "status",
      key: "status",
      render: (status) => <span>{status}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("USER:ACTION_FIELD")}
        </span>
      ),
      dataIndex: "action",
      key: "action",
      render: (action) => action,
    },
  ];

  const doSort = async (sort) => {
    setSorting(sort);

    if (sort) {
      setSorting(sort);
      fetchData(data, sort);
    }
  };

  // const handlePagination = async (page, limit) => {
  //   setPage({ page}, async () => {
  //     await fetchData(
  //     );
  //   });
  // };

  const handlePagination = (a, b) => {
    if (a && b) {
      setPage(a);
      setLimit(b);
    } else {
    }
  };

  const fetchRecommendation = async (
    page,
    limit,
    filters,
    mapping_principal_id
  ) => {
    if (filters.length >= 1) {
      let res = await doGet(
        `/driver/search?page=1&limit=10&filter=depot_id eq ${
          depot ? depot : depot1
        }, driver_name lk ${filters}&${param}`,
        token
      );
      setListRecommendation(res?.data?.payload?.data);
    }
  };

  const onSearchRecommendation = async (value) => {
    setSearchRecommedation(value);
    setIsfilter(true);
    if (value) {
      setSearchRecommedation(value);
      await fetchRecommendation(1, 10, value);
    } else {
    }
  };

  const onSelectRecommendation = (data) => {
    setPage(1)
    setFilter(data);
    fetchData(data, sorting, 1);
    setIsfilter(false);
  };

  const onClearRecommendation = (e) => {
    setIsfilter(false);
    setFilter(null);
    setSearchRecommedation("");
    setListRecommendation([]);

    fetchData("",sorting, 1);

  };

  const options =
    listRecommendation &&
    listRecommendation.map((item) => ({
      value: item.value,
      label: item.value,
    }));

  return (
    <>
      <Delete
        data={data.updated_at}
        id={data.driver_id}
        delete={showDelete}
        title={data.first_name}
        url={"driver"}
        action={() => setShowDelete(false)}
        route={ROUTES.DRIVER.LIST}
        refresh={()=>fetchData("",sorting, 1)}
        token={token}
        param={param}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">

        <Breadcumbs
          jmlLevel={3}
          menuLevel1={`Master`}
          menuLevel2={`Fleet`}
          menuLevel3={`Driver`}
        />

        <h1 className="font-sans-bold text-2xl" id="title">
          {t("Driver")}
        </h1>

        <div
          className={
            style.headerContainer
             + " flex justify-between items-center"
          }
        >
          <div className="flex h-[47px] mr-1">
            <AutoComplete
              options={options}
              value={searchRecommendation}
              onChange={(value) => onSearchRecommendation(value)}
              onSelect={(value) => onSelectRecommendation(value)}
              //  allowClear={true}
            >
              <Input
                placeholder={t("Search Name")}
                suffix={
                  <img
                    onClick={filter ? () => onClearRecommendation() : null}
                    src={filter ? CloseIconSearch : SearchIcon}
                    alt="search"
                  />
                }
                value={searchRecommendation}
                width={350}
                className="w-[350px] h-[47px]"
              />
            </AutoComplete>
            <Select
              className={style.selectContainer + " ml-3 w-[350px]"}
              // "w-[200px] ml-3"
              // size="large"
              // options={dropdown}
              value={depotName ? depotName : depotName1}
              onChange={(id, val) => handleChange(id, val)}
              onPopupScroll={(e) => onScrollDepot(e)}
              dropdownRender={(menu) =>
                dropdownCustom(
                  menu,
                  (value) => onChangeDepot(value),
                  searchValue
                )
              }
              >
              {!loading
                  ? dropdown
                  : [...dropdown]}
              </Select>
          </div>

          {/* <Link to={ROUTES.DRIVER.ADD}> */}
            <PrimaryButton actions="insert"
            menu="driver"
            disabled={dropdown.length===0 || load}
            parent="master" action={() => handleAdd()} text={t("Add Driver")} prefixIcon={<AddIcon />} />
          {/* </Link> */}
        </div>
        {!load ? (
          <div className={style.tableContainer}>
            <CustomTable
              columns={ListColumn}
              data={dataSource}
              showPagination={false}
            />
            <div className={style.containerPagination + " mt-[-45px]"}>
              <CustomPaging
                idLimit="ddlrowsperpagemustselllist"
                idPagination="btnpaginationmustselllist"
                // pagination={pagination}
                size="small"
                current={page}
                defaultCurrent={page}
                pageSize={limit}
                total={initiate && initiate?.count_data}
                pageSizeOptions={initiate && initiate?.valid_limit}
                onShowSizeChange={() => handlePagination()}
                handlePaging={(a, b) => handlePagination(a, b)}
                title={t("COMMON:ROW_PAGE")}
              />
            </div>
          </div>
        ) : (
          "..loading"
        )}
      </div>
    </>
  );
};

export default DriverList;
